import { useMemo } from 'react';
import { authClient } from '@/lib/authClient';

type AuthUser = { id: string; email: string; name?: string | null };
type AuthSession = { user: AuthUser } | null;

export const useAuth = () => {
  // useSession de better-auth es reactivo: se suscribe internamente.
  const { data, isPending } = authClient.useSession();

  const u = data?.user ?? null;
  // useMemo evita crear un nuevo objeto en cada render cuando los valores no cambian
  const user: AuthUser | null = useMemo(
    () => (u ? { id: u.id, email: u.email, name: u.name } : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [u?.id, u?.email, u?.name],
  );
  const session: AuthSession = user ? { user } : null;
  const loading = isPending;

  const signIn = async (email: string, password: string) => {
    const result = await authClient.signIn.email({ email, password });
    return { error: result.error ? new Error(result.error.message) : null };
  };

  const signOut = async () => {
    const result = await authClient.signOut();
    return { error: result.error ? new Error(result.error.message) : null };
  };

  return {
    user,
    session,
    loading,
    signIn,
    signOut,
  };
};
